export default __webpack_public_path__ + "static/What-is-Shopify-dd9d554282c987680a7e03b4e913fb58.jpg";